module.exports = __webpack_public_path__ + "img/loading-indicator.cca3db1c.gif";